import { Injectable } from '@angular/core';
import { AnetCommonService } from '../auth/anet-common.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../../environments/environment';
import { AnonymousModel } from '../models/anonymous.model';
import { firstValueFrom, lastValueFrom, map } from 'rxjs';
import { VideoDownloadLink } from '../models/video-download-link.interface';
import { AthleticFollowInfo } from '../models/athletic-follow-info.interface';
import { AthleticUser } from '../models/athletic-user.interface';

@Injectable({
  providedIn: 'root',
})
export class AnetLiveService {
  constructor(
    private common: AnetCommonService,
    private http: HttpClient,
  ) {}

  async getFollowInfo(sport: string, athleticNetMeetIdStr: string): Promise<AthleticFollowInfo | null> {
    // this.http.post<any>(`${environment.anetAPIEndpoint}/v1/Live2/GetUserData`)
    if (athleticNetMeetIdStr) {
      return firstValueFrom(
        this.http
          .get(
            `${environment.anetAPIEndpoint}/v1/Live2/GetFollowInfo?sport=${sport}&meetId=${athleticNetMeetIdStr}`,
            {},
          )
          .pipe(
            map((data: any) => {
              if (!data) return null;
              const obj: AthleticFollowInfo = data;
              return obj;
            }),
          ),
      );
    } else {
      return null;
    }
  }

  async getUserData(): Promise<AthleticUser | null> {
    // this.http.post<any>(`${environment.anetAPIEndpoint}/v1/Live2/GetUserData`)
    return firstValueFrom(
      this.http.get(`${environment.anetAPIEndpoint}/v1/Live2/GetUserData`).pipe(
        map((data: any) => {
          if (!data) return null;
          const obj: AthleticUser = data;
          return obj;
        }),
      ),
    );
  }

  async getVideoDownloadInfo(videoId: string): Promise<VideoDownloadLink | null> {
    // this.http.post<any>(`${environment.anetAPIEndpoint}/v1/Live2/GetUserData`)
    return firstValueFrom(
      this.http.get(`${environment.anetAPIEndpoint}/v1/Live2/VideoDownloadInfo?videoId=${videoId}`, {}).pipe(
        map((data: any) => {
          if (!data) return null;
          const obj: VideoDownloadLink = data;
          return obj;
        }),
      ),
    );
  }

  async startNotifyingAthlete(linkId: string | number): Promise<boolean> {
    return this.setNotify('A', linkId, true);
  }

  async stopNotifyingAthlete(linkId: string | number): Promise<boolean> {
    return this.setNotify('A', linkId, false);
  }

  async startFollowingAthlete(linkId: string | number, source?: string): Promise<boolean> {
    return this.startFollowing('A', linkId, source);
  }

  async stopFollowingAthlete(linkId: string | number): Promise<boolean> {
    return this.stopFollowing('A', linkId);
  }

  async startNotifyingTeam(linkId: string | number, sport: string): Promise<boolean> {
    return this.setNotify(sport, linkId, true);
  }

  async stopNotifyingTeam(linkId: string | number, sport: string): Promise<boolean> {
    return this.setNotify(sport, linkId, false);
  }

  async startFollowingTeam(teamId: string | number, sport: string, source?: string): Promise<boolean> {
    return firstValueFrom(
      this.http
        .get(
          `${environment.anetAPIEndpoint}/v1/SocialProfile/StartFollowingTeam?teamId=${teamId}&sport=${sport}` +
            (source ? `&source=${source}` : ''),
          {},
        )
        .pipe(
          map((data: any) => {
            const obj: boolean = data;
            return obj;
          }),
        ),
    );
  }

  async stopFollowingTeam(teamId: string | number, sport: string): Promise<boolean> {
    return firstValueFrom(
      this.http
        .get(`${environment.anetAPIEndpoint}/v1/SocialProfile/StopFollowingTeam?teamId=${teamId}&sport=${sport}`, {})
        .pipe(
          map((data: any) => {
            const obj: boolean = data;
            return obj;
          }),
        ),
    );
  }

  protected async setNotify(type: string, linkId: string | number, notify: boolean): Promise<boolean> {
    return firstValueFrom(
      this.http
        .get(
          `${environment.anetAPIEndpoint}/v1/SocialFollow/SetNotify?type=${type}&linkId=${linkId}&notify=${notify}`,
          {},
        )
        .pipe(
          map((data: any) => {
            const obj: boolean = data;
            return obj;
          }),
        ),
    );
  }

  protected async startFollowing(type: string, linkId: string | number, source?: string): Promise<boolean> {
    // this.http.post<any>(`${environment.anetAPIEndpoint}/v1/Live2/GetUserData`)
    return firstValueFrom(
      this.http
        .get(
          `${environment.anetAPIEndpoint}/v1/SocialFollow/StartFollowing?type=${type}&linkId=${linkId}` +
            (source ? `&source=${source}` : ''),
          {},
        )
        .pipe(
          map((data: any) => {
            const obj: boolean = data;
            return obj;
          }),
        ),
    );
  }

  protected async stopFollowing(type: string, linkId: string | number): Promise<boolean> {
    // this.http.post<any>(`${environment.anetAPIEndpoint}/v1/Live2/GetUserData`)
    return firstValueFrom(
      this.http
        .get(`${environment.anetAPIEndpoint}/v1/SocialFollow/StopFollowing?type=${type}&linkId=${linkId}`, {})
        .pipe(
          map((data: any) => {
            const obj: boolean = data;
            return obj;
          }),
        ),
    );
  }
}
